import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { FireDataService } from './fire-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  title: string;
  user = {};
  name: string;

  
  constructor(private fds: FireDataService, private router: Router, private route: ActivatedRoute) { 
 
    this.title ="myLiceo app";
    this.isLogged()

  }

  private nameSplit() {
    var b = this.user['displayName'].split(' ');
    if (b[0]) {this.name = b[0]}
  }

   home() {
    this.router.navigate(["/home"]);
  }

   account() {
    this.router.navigate(["/login", 'true']);
  }

    isLogged() {
        this.fds.user.subscribe(res => {
        if (res) {
          this.user = res;
          this.nameSplit();
        }
        if (!res) {
        this.user = {};
        this.user['email'] = '', this.user['photoURL'] = ''; this.name = '';
        }
    });
  }

}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/app.component.ts